module.exports = __webpack_public_path__ + "img/ic-reg-success.32f44943.svg";